<template>
	<div class="animated fadeIn">

		<b-row>
			<b-col sm="12">

				<b-card header="Timesheet" v-if="loading.timesheet || loading.rate || loading.employee">Loading, please wait...</b-card>
				<b-card header="Timesheet" v-else-if="!subscribed">You do not have an active subscription, see 'Subscription' in the upper right dropdown</b-card>
				<b-card header="Timesheet" v-else>

                    <div><b-button-toolbar>
                        <b-button-group><b-button variant="secondary" size="sm" v-on:click="previousClicked">&lt;</b-button></b-button-group>
                        <b-input-group><b-form-input type="date" id="selectedDate" required="required" v-model="dates.dateString" v-on:change="dateStringChanged"></b-form-input></b-input-group>
                        <b-button-group><b-button variant="secondary" size="sm" v-on:click="nextClicked">&gt;</b-button></b-button-group>
                        <b-input-group class="mx-2"><b-form-select :plain="true" :options="employeeOptions" v-model="selectedEmployee" v-on:change="employeeChanged"></b-form-select></b-input-group>
                    </b-button-toolbar></div>

                    <br>

					<b-table hover="true" striped="true" bordered="true" small="true" responsive="md" :items="items" :fields="fields" current-page="1" per-page="100">
						

						<!--TODO: send to and from db-->

						<!--TODO: add lock/approval-->

						<!--TODO: (optional) set default bill rate, or allow removing bill rate column (only one bill rate per project per employee)?-->

						<!--TODO: (optional) allow <0 and >24 hours with comments-->
	                    <!--TODO: (optional) add tabular view-->
						<!--TODO: (optional) notes: multi line and red triangle -->

                        <!--TODO: (optional) ask for save before moving away?-->

						
						<template slot="project" slot-scope="data">
								<b-form-select size="sm" :options="projectOptions" v-model="data.item.project" v-on:change="projectChanged($event, data.index)"></b-form-select>
						</template>
						<template slot="rate" slot-scope="data">
								<b-form-select size="sm" :options="findRateOptions(data.item.project)" v-model="data.item.rate"></b-form-select>
						</template>
						<template slot="mon" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.mon" v-on:focus.native="enterTimeEntry($event, data.item.monNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'mon')"></b-form-input>
						</template>
						<template slot="tue" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.tue" v-on:focus.native="enterTimeEntry($event, data.item.tueNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'tue')"></b-form-input>
						</template>
						<template slot="wed" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.wed" v-on:focus.native="enterTimeEntry($event, data.item.wedNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'wed')"></b-form-input>
						</template>
						<template slot="thu" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.thu" v-on:focus.native="enterTimeEntry($event, data.item.thuNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'thu')"></b-form-input>
						</template>
						<template slot="fri" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.fri" v-on:focus.native="enterTimeEntry($event, data.item.friNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'fri')"></b-form-input>
						</template>
						<template slot="sat" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.sat" v-on:focus.native="enterTimeEntry($event, data.item.satNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'sat')"></b-form-input>
						</template>
						<template slot="sun" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.sun" v-on:focus.native="enterTimeEntry($event, data.item.sunNotes)" v-on:blur.native="leaveTimeEntry($event, data.index,'sun')"></b-form-input>
						</template>
						<template slot="total" slot-scope="data">
							<div v-if="data.item.project.length != 0">
								{{Number(data.item.mon)+Number(data.item.tue)+Number(data.item.wed)+Number(data.item.thu)+Number(data.item.fri)+Number(data.item.sat)+Number(data.item.sun)}}
							</div>
						</template>

						<template slot="bottom-row" slot-scope="data">
							<td>Total</td>
							<td></td>
							<td>{{getColumnSum(items,'mon')}}</td>
							<td>{{getColumnSum(items,'tue')}}</td>
							<td>{{getColumnSum(items,'wed')}}</td>
							<td>{{getColumnSum(items,'thu')}}</td>
							<td>{{getColumnSum(items,'fri')}}</td>
							<td>{{getColumnSum(items,'sat')}}</td>
							<td>{{getColumnSum(items,'sun')}}</td>
							<td>{{getColumnSum(items,'total')}}</td>
						</template>

					</b-table>

					<b-form-input id="notes" placeholder="" disabled="true" v-on:focus.native="enterNotes" v-on:blur.native="leaveNotes"></b-form-input>
					<br>

					<b-alert id="alertMessage" v-bind:variant=this.alertMessage.variant v-bind:show=this.alertMessage.show>{{this.alertMessage.message}}</b-alert>

                    <b-button variant="primary" v-if="this.currentUser.email == this.selectedEmployee" v-on:click="saveClicked">Save</b-button>
					<b-button variant="primary" v-else disabled>Save</b-button>
                    <b-button variant="link" v-on:click="cancelClicked">Cancel</b-button>
					<br><br>

				</b-card>

			</b-col>
		</b-row>
		<!--TODO: this is only for debugging, remove when done-->
		<!--{{this.dbRates}}-->
	</div>

</template>



<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import axios from 'axios'

export default {
	name: 'tables',

	data: () => {
		return {
			items: [
				//{project: 'Project 1', rate: 'Sr Engineer', mon: 1, tue: 2, wed: null, thu: 1, fri: null, sat: null, sun: null, monNotes: 'Note 1', tueNotes: '', wedNotes: '', thuNotes: '', friNotes: '', satNotes: '', sunNotes: ''},
				//{project: 'Project 2', rate: 'Sr Engineer', mon: 2, tue: 2, wed: 1, thu: null, fri: null, sat: null, sun: null, monNotes: 'Note 2', tueNotes: '', wedNotes: '', thuNotes: '', friNotes: '', satNotes: '', sunNotes: ''}
            ],
            
			fields: {
					project: {label: 'Project', thStyle: {minWidth: '210px'}},
					rate: {label: 'Bill Rate', thStyle: {width: '140px', minWidth: '140px'}},
					mon: {label: 'Mon', thStyle: {width: '70px'}},
					tue: {label: 'Tue', thStyle: {width: '70px'}},
					wed: {label: 'Wed', thStyle: {width: '70px'}},
					thu: {label: 'Thu', thStyle: {width: '70px'}},
					fri: {label: 'Fri', thStyle: {width: '70px'}},
					sat: {label: 'Sat', thStyle: {width: '70px'}},
					sun: {label: 'Sun', thStyle: {width: '70px'}},
					total: {label: 'Total', thStyle: {width: '70px'}}
            },

            //returned from database for a specified employee and one week range
            //(not yet true) "project + rate + date + notes" is already unique
			//"project" and "rate" are already not blank
			//"hours" is already valid (numbers, >=0 and <=24, sum <= 24, not 0 without notes, not empty string or null)
			//"date" is already in YYYY-MM-DD (from postgresql DATE datatype)
            dbTimesheets: [
				/*
                {project: 'Project 1', date: '2018-10-29', hours: 1, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 1', date: '2018-10-30', hours: 2, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 1', date: '2018-11-01', hours: 1, notes: 'some notes', rate: 'Sr Engineer'},
                {project: 'Project 2', date: '2018-10-29', hours: 2, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 2', date: '2018-10-30', hours: 2, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 2', date: '2018-10-31', hours: 1, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 3', date: '2018-10-30', hours: 5, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 3', date: '2018-11-01', hours: 2, notes: '', rate: 'Sr Engineer'},
                {project: 'Project 3', date: '2018-11-02', hours: 8, notes: '', rate: 'Sr Engineer'}
				*/
            ],

			dbTimesheetsToBeSaved: [],

            //returned from database for a specified employee
			//TODO (optional): default is just placeholder not working yet
            //TODO (optional): for each project there is already only one default to true
            dbRates: [
				/*
                {project: 'Project 1', rate: 'Engineer', value: 100, default: false},
                {project: 'Project 1', rate: 'Sr Engineer', value: 150, default: true},
                {project: 'Project 2', rate: 'Sr Engineer', value: 150, default: true},
                {project: 'Project 3', rate: 'Engineer', value: 150, default: true},
                {project: 'Project 3', rate: 'Sr Engineer', value: 150, default: false},
                {project: 'Project 4', rate: 'Development', value: 200, default: true},
                {project: 'Project 4', rate: 'QA', value: 200, default: false}
				*/

				/*
				{project: 'Project 1', rate: 'Engineer', value: 100, projectid: 'uuid_pj', rateid: 'uuid_br'}
				*/
			],
			
			dbRatesCopy: [],		//a copy of dbRates before adding project/rate needed for existing entries in a week's timesheets

			projectOptions: [],		//array of strings

			rateOptions: [],		//array of {project: <project string>, rates: <array of rate strings>, default: <rate string>}

			employeeOptions: [],	//array of {value: <email>, text: <name>}

            dates: {
                dateString: '',		//YYYY-MM-DD, used by date form input
                date: null,         //Date datatype
                startDate: null,    //Date datatype
                endDate: null       //Date datatype
            },

			selectedTimeEntry: {
				row: null,
				col: ''
			},

			selectedEmployee: '',	//email

			currentUser: {
				cognitoUser: null,
				email: '',
				role: '',
				company: '',
				token: ''
			},

			alertMessage: {
				show: false,
				variant: 'success',		//'success' or 'danger'
				message: ''
			},

			subscribed: true,

			loading: {
				timesheet: true,
				rate: true,
				employee: true
			}

		}
	},

	mounted() {
		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentUser.cognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					vueInstance.currentUser.token = session.getIdToken().getJwtToken();
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}

						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "custom:company")
								vueInstance.currentUser.company = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.currentUser.role = result[i].getValue();
							else if (result[i].getName() == "email")
								vueInstance.currentUser.email = result[i].getValue();
						}


						vueInstance.setToday();
						vueInstance.setDateString();
						vueInstance.selectedEmployee = vueInstance.currentUser.email;
						vueInstance.loading.employee = true;
						axios.get('/user-admin/active-employee-list', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								vueInstance.employeeOptions = JSON.parse(JSON.stringify(response.data));
								vueInstance.loading.employee = false;
							})
							.catch(function (error) {
							});

						vueInstance.loading.rate = true;
						axios.get('/timesheet/rates', {params:{token:vueInstance.currentUser.token,email:vueInstance.currentUser.email}})
							.then(function (response) {
								vueInstance.dbRates = JSON.parse(JSON.stringify(response.data));
								vueInstance.dbRatesCopy = JSON.parse(JSON.stringify(response.data));
								//vueInstance.convertDbRatesToOptions();
								vueInstance.loading.rate = false;
								vueInstance.updateTable();
							})
							.catch(function (error) {
							});

						/*
						axios.get('/user-admin/stripe', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								if (response.data.currentPlan == 'cancel')
									vueInstance.subscribed = false;
							})
							.catch(function (error) {
							});
						*/



					});
				}

			});
		}






    },

    updated() {

		//TODO: the following assumes "this.dates.date" is already set to today in dateStringChanged, need to check different browsers
		if (!this.validateDateString()) {
			this.setDateString();
		}
			
    },

	methods: {
		getColumnSum (items, field) {
			var sum = 0;
			for (var i = 0; i < items.length; i++) {
				switch (field) {
					case 'mon':
						sum += Number(items[i].mon);
						break;
					case 'tue':
						sum += Number(items[i].tue);
						break;
					case 'wed':
						sum += Number(items[i].wed);
						break;
					case 'thu':
						sum += Number(items[i].thu);
						break;
					case 'fri':
						sum += Number(items[i].fri);
						break;
					case 'sat':
						sum += Number(items[i].sat);
						break;
					case 'sun':
						sum += Number(items[i].sun);
						break;
					case 'total':
						sum += Number(items[i].mon);
						sum += Number(items[i].tue);
						sum += Number(items[i].wed);
						sum += Number(items[i].thu);
						sum += Number(items[i].fri);
						sum += Number(items[i].sat);
						sum += Number(items[i].sun);
						break;
					default:
				}
			}
			return sum;
        },

		findItem (project, rate, date) {		//pass params from dbTimesheets
			var dateObject = this.convertDateStringToDate(date);

			for (var i = 0; i < this.items.length; i++) {
				if ((project == this.items[i].project) && (rate == this.items[i].rate)) {
			
					switch (dateObject.getDay()) {
						case 0:
							//sun
							if ((this.items[i].sun == null) && (this.items[i].sunNotes == ''))
								return i;
							break;
						case 1:
							//mon
							if ((this.items[i].mon == null) && (this.items[i].monNotes == ''))
								return i;
							break;
						case 2:
							//tue
							if ((this.items[i].tue == null) && (this.items[i].tueNotes == ''))
								return i;
							break;
						case 3:
							//wed
							if ((this.items[i].wed == null) && (this.items[i].wedNotes == ''))
								return i;
							break;
						case 4:
							//thu
							if ((this.items[i].thu == null) && (this.items[i].thuNotes == ''))
								return i;
							break;
						case 5:
							//fri
							if ((this.items[i].fri == null) && (this.items[i].friNotes == ''))
								return i;
							break;
						case 6:
							//sat
							if ((this.items[i].sat == null) && (this.items[i].satNotes == ''))
								return i;
							break;
						default:
					}

				}
			}
			return -1;
		},

        convertItemsToDbTimesheetsToBeSaved () {
			var timesheets = [];

			var currentDate = new Date(this.dates.startDate.getFullYear(), this.dates.startDate.getMonth(), this.dates.startDate.getDate());
			var monDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
			currentDate.setDate(currentDate.getDate() + 1);
			var tueDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
			currentDate.setDate(currentDate.getDate() + 1);
			var wedDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
			currentDate.setDate(currentDate.getDate() + 1);
			var thuDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
			currentDate.setDate(currentDate.getDate() + 1);
			var friDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
			currentDate.setDate(currentDate.getDate() + 1);
			var satDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
			currentDate.setDate(currentDate.getDate() + 1);
			var sunDateString = currentDate.getFullYear() + '-' + (currentDate.getMonth() < 9 ? '0' : '') + (currentDate.getMonth() + 1) + '-' + (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();

			for (var i = 0; i < this.items.length; i++) {
				if ((Number(this.items[i].mon) > 0) || (this.items[i].monNotes != ''))
					timesheets.push({project: this.items[i].project, date: monDateString, hours: Number(this.items[i].mon), notes: this.items[i].monNotes, rate: this.items[i].rate});
				if ((Number(this.items[i].tue) > 0) || (this.items[i].tueNotes != ''))
					timesheets.push({project: this.items[i].project, date: tueDateString, hours: Number(this.items[i].tue), notes: this.items[i].tueNotes, rate: this.items[i].rate});
				if ((Number(this.items[i].wed) > 0) || (this.items[i].wedNotes != ''))
					timesheets.push({project: this.items[i].project, date: wedDateString, hours: Number(this.items[i].wed), notes: this.items[i].wedNotes, rate: this.items[i].rate});
				if ((Number(this.items[i].thu) > 0) || (this.items[i].thuNotes != ''))
					timesheets.push({project: this.items[i].project, date: thuDateString, hours: Number(this.items[i].thu), notes: this.items[i].thuNotes, rate: this.items[i].rate});
				if ((Number(this.items[i].fri) > 0) || (this.items[i].friNotes != ''))
					timesheets.push({project: this.items[i].project, date: friDateString, hours: Number(this.items[i].fri), notes: this.items[i].friNotes, rate: this.items[i].rate});
				if ((Number(this.items[i].sat) > 0) || (this.items[i].satNotes != ''))
					timesheets.push({project: this.items[i].project, date: satDateString, hours: Number(this.items[i].sat), notes: this.items[i].satNotes, rate: this.items[i].rate});
				if ((Number(this.items[i].sun) > 0) || (this.items[i].sunNotes != ''))
					timesheets.push({project: this.items[i].project, date: sunDateString, hours: Number(this.items[i].sun), notes: this.items[i].sunNotes, rate: this.items[i].rate});
			}

            //TODO (optional): for duplicated "project + rate + date + notes", combine hours in timesheets

			//alert(JSON.stringify(timesheets));
			this.dbTimesheetsToBeSaved = timesheets;
        },

        convertDbTimesheetsToItems () {
            //(not yet true) dbTimesheets was from database so "project + rate + date + notes" is already unique
            this.items = [];
			for (var i = 0; i < this.dbTimesheets.length; i++) {

				var itemIndex = this.findItem(this.dbTimesheets[i].project, this.dbTimesheets[i].rate, this.dbTimesheets[i].date);
				if (itemIndex == -1) {
					for (var j = 0; j < this.dbRates.length; j++) {
						if ((this.dbRates[j].project == this.dbTimesheets[i].project) && (this.dbRates[j].rate == this.dbTimesheets[i].rate))
							break
					}
					if (j == this.dbRates.length)	//project+rate not found
						this.dbRates.push({project: this.dbTimesheets[i].project, rate: this.dbTimesheets[i].rate, value: 0, projectid: '', rateid: ''})	//set value, projectid, rateid later in getNewDbRatesFromDb

					this.items.push({project: this.dbTimesheets[i].project, rate: this.dbTimesheets[i].rate, mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, monNotes: '', tueNotes: '', wedNotes: '', thuNotes: '', friNotes: '', satNotes: '', sunNotes: ''});
					itemIndex = (this.items.length - 1)
				};
				
				var dateObject = this.convertDateStringToDate(this.dbTimesheets[i].date);
				switch (dateObject.getDay()) {
					case 0:
						//sun
						this.items[itemIndex].sun = this.dbTimesheets[i].hours;
						this.items[itemIndex].sunNotes = this.dbTimesheets[i].notes;
						break;
					case 1:
						//mon
						this.items[itemIndex].mon = this.dbTimesheets[i].hours;
						this.items[itemIndex].monNotes = this.dbTimesheets[i].notes;
						break;
					case 2:
						//tue
						this.items[itemIndex].tue = this.dbTimesheets[i].hours;
						this.items[itemIndex].tueNotes = this.dbTimesheets[i].notes;
						break;
					case 3:
						//wed
						this.items[itemIndex].wed = this.dbTimesheets[i].hours;
						this.items[itemIndex].wedNotes = this.dbTimesheets[i].notes;
						break;
					case 4:
						//thu
						this.items[itemIndex].thu = this.dbTimesheets[i].hours;
						this.items[itemIndex].thuNotes = this.dbTimesheets[i].notes;
						break;
					case 5:
						//fri
						this.items[itemIndex].fri = this.dbTimesheets[i].hours;
						this.items[itemIndex].friNotes = this.dbTimesheets[i].notes;
						break;
					case 6:
						//sat
						this.items[itemIndex].sat = this.dbTimesheets[i].hours;
						this.items[itemIndex].satNotes = this.dbTimesheets[i].notes;
						break;
					default:
				};
					
			};

			this.convertDbRatesToOptions();

			//add empty rows at the end so there are at least 5 total rows and 1 empty row
			var itemLength = this.items.length;
			for (i = 0; i < ((itemLength >= 5) ? 1 : (5 - itemLength)); i++)
            	this.items.push({project: '', rate: '', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, monNotes: '', tueNotes: '', wedNotes: '', thuNotes: '', friNotes: '', satNotes: '', sunNotes: ''});

			//hide old alert message since we are refreshing the page
			this.alertMessage.show = false;

        },

		convertDbRatesToOptions () {
			//projectOptions
			this.projectOptions = [''];		//add empty as first option
			for (var i = 0; i < this.dbRates.length; i++) {
				if (this.projectOptions.indexOf(this.dbRates[i].project) < 0)
					this.projectOptions.push(this.dbRates[i].project);
			};

			//rateOptions
			this.rateOptions = [];
			var projectRateOptions = [];
			var projectRateDefault = '';
			for (var i = 1; i < this.projectOptions.length; i++) {	//skip first empty project option
				//projectRateOptions = [];
				projectRateOptions = [''];	//add empty as first option
				projectRateDefault = '';
				for (var j = 0; j < this.dbRates.length; j++) {
					if (this.dbRates[j].project == this.projectOptions[i]) {
						projectRateOptions.push(this.dbRates[j].rate);
						//if (this.dbRates[j].default)
						//	projectRateDefault = this.dbRates[j].rate;
					}
				}
				this.rateOptions.push({project: this.projectOptions[i], rates: projectRateOptions, default: projectRateDefault});
			};
		},

		findRateOptions (project) {
			for (var i = 0; i < this.rateOptions.length; i++) {
				if (project == this.rateOptions[i].project)
					return this.rateOptions[i].rates;
			};
			return [''];
		},

		findRateDefault (project) {
			for (var i = 0; i < this.rateOptions.length; i++) {
				if (project == this.rateOptions[i].project)
					return this.rateOptions[i].default;
			};
			return '';
		},

		getDbTimesheetsFromDb (email,week) {
			var vueInstance = this;
			vueInstance.loading.timesheet = true;
			axios.get('/timesheet/weekly-timesheet', {params:{token:vueInstance.currentUser.token,email:email,week:week}})
				.then(function (response) {
					vueInstance.dbTimesheets = JSON.parse(JSON.stringify(response.data));
					vueInstance.convertDbTimesheetsToItems();
					vueInstance.getNewDbRatesFromDb();
					//vueInstance.loading.timesheet = false;	//moved inside getNewDbRatesFromDb
				})
				.catch(function (error) {
				});

		},

		getNewDbRatesFromDb () {
			var dbRatesToBeUpdated = []
			for (var i = 0; i < this.dbRates.length; i++) {
				if (this.dbRates[i].projectid == '') {
					dbRatesToBeUpdated.push(JSON.parse(JSON.stringify(this.dbRates[i])))
					this.dbRates.splice(i,1)
					i -= 1
				}
			}
			if (dbRatesToBeUpdated.length > 0) {
				var vueInstance = this;
				axios.get('/timesheet/new-rates', {params:{token:vueInstance.currentUser.token,rates:dbRatesToBeUpdated}})
					.then(function (response) {
						for (i = 0; i < response.data.length; i++) {
							vueInstance.dbRates.push(JSON.parse(JSON.stringify(response.data[i])))
						}
						vueInstance.loading.timesheet = false;
					})
					.catch(function (error) {
					});
			}
			else
				this.loading.timesheet = false;
		},

		/*
		getDbRatesFromDb (email) {
			var vueInstance = this;
			vueInstance.loading.rate = true;
			axios.get('/timesheet/rates', {params:{token:vueInstance.currentUser.token,email:email}})
				.then(function (response) {
					vueInstance.dbRates = JSON.parse(JSON.stringify(response.data));
					vueInstance.dbRatesCopy = JSON.parse(JSON.stringify(response.data));
					vueInstance.convertDbRatesToOptions();
					vueInstance.loading.rate = false;
				})
				.catch(function (error) {
				});

		},
		*/

        previousClicked: function (event) {
            event.target.blur();
            this.dates.date.setDate(this.dates.date.getDate() - 7);
			this.setDateString();
			this.dbRates = JSON.parse(JSON.stringify(this.dbRatesCopy))
			this.updateTable();
        },

        nextClicked: function (event) {
            event.target.blur();
            this.dates.date.setDate(this.dates.date.getDate() + 7);
			this.setDateString();
			this.dbRates = JSON.parse(JSON.stringify(this.dbRatesCopy))
			this.updateTable();
        },

		convertDateStringToDate (dateString) {
			var ymd = dateString.split('-');
			var y = Number(ymd[0]);
			var m = Number(ymd[1]) - 1;
			var d = Number(ymd[2]);
			return new Date(y,m,d);
		},

        employeeChanged: function (event) {

			this.selectedEmployee = event;		//TODO: this line is needed because somehow v-model doesn't work, need to find out why

			var vueInstance = this;
			vueInstance.loading.rate = true;
			axios.get('/timesheet/rates', {params:{token:vueInstance.currentUser.token,email:event}})
				.then(function (response) {
					vueInstance.dbRates = JSON.parse(JSON.stringify(response.data));
					vueInstance.dbRatesCopy = JSON.parse(JSON.stringify(response.data));
					//vueInstance.convertDbRatesToOptions();
					vueInstance.loading.rate = false;
					vueInstance.getDbTimesheetsFromDb(event,vueInstance.dates.dateString);
				})
				.catch(function (error) {
				});

		},

        dateStringChanged: function (event) {

			//TODO: the following assumes "this.dates.dateString" is already set to the new value, need to check different browsers
			
			//update date from dateString
			if (!this.validateDateString()) {
				this.setToday();
			}
			else {
				this.dates.date = this.convertDateStringToDate(this.dates.dateString);
			}

			this.dbRates = JSON.parse(JSON.stringify(this.dbRatesCopy))
			this.updateTable();

			//document.getElementById("selectedDate").blur();
            //event.target.blur();	//not working

        },

		projectChanged: function (event, index) {
			//Note: the following does not work, probably because rate options are not yet updated
			//Note: setting invalid rate may remove the "rate" field from the JSON???
			//this.items[index].rate = this.findRateDefault(this.items[index].project);

			//TODO (optional): if there is only one rate, set default to be the one rate instead of blank
			this.items[index].rate = '';

			//add empty row if user uses the last row
			if (index == (this.items.length - 1))
				this.items.push({project: '', rate: '', mon: null, tue: null, wed: null, thu: null, fri: null, sat: null, sun: null, monNotes: '', tueNotes: '', wedNotes: '', thuNotes: '', friNotes: '', satNotes: '', sunNotes: ''});
		},

        cancelClicked: function (event) {
            event.target.blur();
            this.convertDbTimesheetsToItems();
        },

        saveClicked: function (event) {
            event.target.blur();

			var errorMessage = '';
			var monSum = 0;
			var tueSum = 0;
			var wedSum = 0;
			var thuSum = 0;
			var friSum = 0;
			var satSum = 0;
			var sunSum = 0;
			var currentRateOptions = [];

			for (var i = 0; i < this.items.length; i++) {
				//set rate if only one rate
				currentRateOptions = this.findRateOptions(this.items[i].project);
				if ((this.items[i].project != '') && (this.items[i].rate == '') && (currentRateOptions.length == 2))	//length == 2 because the first one is blank
					this.items[i].rate = currentRateOptions[1];

				//if hour is blank and notes is not empty, set hour to 0
				if (((this.items[i].mon == null) || (this.items[i].mon == '')) && (this.items[i].monNotes != ''))
					this.items[i].mon = 0;
				if (((this.items[i].tue == null) || (this.items[i].tue == '')) && (this.items[i].tueNotes != ''))
					this.items[i].tue = 0;
				if (((this.items[i].wed == null) || (this.items[i].wed == '')) && (this.items[i].wedNotes != ''))
					this.items[i].wed = 0;
				if (((this.items[i].thu == null) || (this.items[i].thu == '')) && (this.items[i].thuNotes != ''))
					this.items[i].thu = 0;
				if (((this.items[i].fri == null) || (this.items[i].fri == '')) && (this.items[i].friNotes != ''))
					this.items[i].fri = 0;
				if (((this.items[i].sat == null) || (this.items[i].sat == '')) && (this.items[i].satNotes != ''))
					this.items[i].sat = 0;
				if (((this.items[i].sun == null) || (this.items[i].sun == '')) && (this.items[i].sunNotes != ''))
					this.items[i].sun = 0;

				if (errorMessage == '') {
					//validate hours are numbers
					if (isNaN(this.items[i].mon) || isNaN(this.items[i].tue) || isNaN(this.items[i].wed) || isNaN(this.items[i].thu) || isNaN(this.items[i].fri) || isNaN(this.items[i].sat) || isNaN(this.items[i].sun))
						errorMessage = 'Invalid input (hours must be numbers)';
					//validate hours are >=0 and <=24
					/*
					else if ((Number(this.items[i].mon) < 0) || (Number(this.items[i].mon) > 24) || (Number(this.items[i].tue) < 0) || (Number(this.items[i].tue) > 24) || (Number(this.items[i].wed) < 0) || (Number(this.items[i].wed) > 24) || (Number(this.items[i].thu) < 0) || (Number(this.items[i].thu) > 24) || (Number(this.items[i].fri) < 0) || (Number(this.items[i].fri) > 24) || (Number(this.items[i].sat) < 0) || (Number(this.items[i].sat) > 24) || (Number(this.items[i].sun) < 0) || (Number(this.items[i].sun) > 24))
						errorMessage = 'Invalid input (hours must be between 0 and 24)';
					*/
					//validate non-blank project (ignore row if no hours and no notes)
					else if ((this.items[i].project == '') && ((Number(this.items[i].mon) > 0) || (Number(this.items[i].tue) > 0) || (Number(this.items[i].wed) > 0) || (Number(this.items[i].thu) > 0) || (Number(this.items[i].fri) > 0) || (Number(this.items[i].sat) > 0) || (Number(this.items[i].sun) > 0) || (this.items[i].monNotes != '') || (this.items[i].tueNotes != '') || (this.items[i].wedNotes != '') || (this.items[i].thuNotes != '') || (this.items[i].friNotes != '') || (this.items[i].satNotes != '') || (this.items[i].sunNotes != '')))
						errorMessage = 'Invalid input (project cannot be blank)';
					//validate non-blank rate (ignore row if no hours and no notes)
					else if ((this.items[i].rate == '') && ((Number(this.items[i].mon) > 0) || (Number(this.items[i].tue) > 0) || (Number(this.items[i].wed) > 0) || (Number(this.items[i].thu) > 0) || (Number(this.items[i].fri) > 0) || (Number(this.items[i].sat) > 0) || (Number(this.items[i].sun) > 0) || (this.items[i].monNotes != '') || (this.items[i].tueNotes != '') || (this.items[i].wedNotes != '') || (this.items[i].thuNotes != '') || (this.items[i].friNotes != '') || (this.items[i].satNotes != '') || (this.items[i].sunNotes != '')))
						errorMessage = 'Invalid input (bill rate cannot be blank)';

					monSum += Number(this.items[i].mon);
					tueSum += Number(this.items[i].tue);
					wedSum += Number(this.items[i].wed);
					thuSum += Number(this.items[i].thu);
					friSum += Number(this.items[i].fri);
					satSum += Number(this.items[i].sat);
					sunSum += Number(this.items[i].sun);
				};
			};

			//validate hours (sum <= 24)
			/*
			if (errorMessage == '') {
				if ((monSum > 24) || (tueSum > 24) || (wedSum > 24) || (thuSum > 24) || (friSum > 24) || (satSum > 24) || (sunSum > 24))
					errorMessage = 'Invalid input (total hours for a day must be less than 24)';
			};
			*/

			if (errorMessage != '') {
				//alert(errorMessage);
				this.alertMessage.message = errorMessage;
				this.alertMessage.variant = 'danger';
				this.alertMessage.show = true;
			}
			else {

				event.target.disabled = true;
				this.alertMessage.show = false;
				this.alertMessage.variant = 'success';
				this.alertMessage.message = '';

				this.convertItemsToDbTimesheetsToBeSaved();

				var vueInstance = this;
				axios.put('/timesheet/weekly-timesheet', {token:vueInstance.currentUser.token, startDate:vueInstance.dates.startDate.toISOString().substring(0,10), endDate:vueInstance.dates.endDate.toISOString().substring(0,10), timesheet:vueInstance.dbTimesheetsToBeSaved, rates: vueInstance.dbRates})
					.then(function (response) {
						vueInstance.dbTimesheets = JSON.parse(JSON.stringify(vueInstance.dbTimesheetsToBeSaved));
						vueInstance.dbTimesheetsToBeSaved = [];
						vueInstance.alertMessage.message = 'Timesheet for week of ' + vueInstance.dates.startDate.toISOString().substring(0,10) + ' saved successfully.';
						vueInstance.alertMessage.variant = 'success';
						vueInstance.alertMessage.show = true;
						event.target.disabled = false;
					})
					.catch(function (error) {
						vueInstance.alertMessage.message = 'Update failed. Please try again later.';
						vueInstance.alertMessage.variant = 'danger';
						vueInstance.alertMessage.show = true;
						event.target.disabled = false;
					});


			};

        },

        //"data.dates.date" and "data.dates.dateString" are already updated when updateTable is called
        updateTable () {
            var startDateObject = new Date(this.dates.date.getFullYear(), this.dates.date.getMonth(), this.dates.date.getDate());
            var endDateObject = new Date(this.dates.date.getFullYear(), this.dates.date.getMonth(), this.dates.date.getDate());

            startDateObject.setDate(this.dates.date.getDate() - (this.dates.date.getDay() == 0 ? 6 : (this.dates.date.getDay() - 1)));
            this.dates.startDate = startDateObject;

            endDateObject.setDate(this.dates.date.getDate() + (this.dates.date.getDay() == 0 ? 0 : (7 - this.dates.date.getDay())));
            this.dates.endDate = endDateObject;

            var currentDateObject = new Date(this.dates.startDate.getFullYear(), this.dates.startDate.getMonth(), this.dates.startDate.getDate());

            this.fields.mon.label = "Mon<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();
            currentDateObject.setDate(currentDateObject.getDate() + 1);
            this.fields.tue.label = "Tue<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();
            currentDateObject.setDate(currentDateObject.getDate() + 1);
            this.fields.wed.label = "Wed<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();
            currentDateObject.setDate(currentDateObject.getDate() + 1);
            this.fields.thu.label = "Thu<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();
            currentDateObject.setDate(currentDateObject.getDate() + 1);
            this.fields.fri.label = "Fri<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();
            currentDateObject.setDate(currentDateObject.getDate() + 1);
            this.fields.sat.label = "Sat<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();
            currentDateObject.setDate(currentDateObject.getDate() + 1);
            this.fields.sun.label = "Sun<br>" + (currentDateObject.getMonth() + 1) + "/" + currentDateObject.getDate();

			this.getDbTimesheetsFromDb(this.selectedEmployee,this.dates.dateString);

			//TODO: (optional) disable date input arrows (and keyboard up and down)

        },

		setToday () {
        	this.dates.date = new Date();
		},

		//set dateString based on date
		setDateString () {
			this.dates.dateString = this.dates.date.getFullYear() + '-' + (this.dates.date.getMonth() < 9 ? '0' : '') + (this.dates.date.getMonth() + 1) + '-' + (this.dates.date.getDate() < 10 ? '0' : '') + this.dates.date.getDate();
		},

		validateDateString () {
			if (this.dates.dateString.length != 10)
				return false;
			var ymd = this.dates.dateString.split('-');
			if ((ymd[0].length != 4) || (ymd[1].length != 2) || (ymd[2].length != 2))
				return false;
			if (!((/^\d+$/.test(ymd[0])) && (/^\d+$/.test(ymd[1])) && (/^\d+$/.test(ymd[2]))))
				return false;
			var y = Number(ymd[0]);
			var m = Number(ymd[1]);
			var d = Number(ymd[2]);
			if ((y < 1900) || (y > 2100) || (m < 1) || (m > 12) || (d < 1) || (d > 31))
				return false;
			return true;
		},

		enterTimeEntry: function (event, selectedNotes) {
			document.getElementById("notes").disabled = false;
			document.getElementById("notes").placeholder = 'Enter notes for the selected time entry';
			document.getElementById("notes").value = selectedNotes;
		},
 
		leaveTimeEntry: function (event, row, col) {
			if (event.relatedTarget == null) {
				document.getElementById("notes").value = '';
				document.getElementById("notes").placeholder = '';
				document.getElementById("notes").disabled = true;
			}
			else if (event.relatedTarget.id == 'notes') {
				this.selectedTimeEntry.row = row;
				this.selectedTimeEntry.col = col;
			}
			else {
				document.getElementById("notes").value = '';
				document.getElementById("notes").placeholder = '';
				document.getElementById("notes").disabled = true;
			}
			
		},

		enterNotes: function (event) {
			
		},

		leaveNotes: function (event) {
			if (this.selectedTimeEntry.col == 'mon')
				this.items[this.selectedTimeEntry.row].monNotes = event.target.value;
			else if (this.selectedTimeEntry.col == 'tue')
				this.items[this.selectedTimeEntry.row].tueNotes = event.target.value;
			else if (this.selectedTimeEntry.col == 'wed')
				this.items[this.selectedTimeEntry.row].wedNotes = event.target.value;
			else if (this.selectedTimeEntry.col == 'thu')
				this.items[this.selectedTimeEntry.row].thuNotes = event.target.value;
			else if (this.selectedTimeEntry.col == 'fri')
				this.items[this.selectedTimeEntry.row].friNotes = event.target.value;
			else if (this.selectedTimeEntry.col == 'sat')
				this.items[this.selectedTimeEntry.row].satNotes = event.target.value;
			else if (this.selectedTimeEntry.col == 'sun')
				this.items[this.selectedTimeEntry.row].sunNotes = event.target.value;
			this.selectedTimeEntry.row = null;
			this.selectedTimeEntry.col = '';
			event.target.value = '';
			event.target.placeholder = '';
			event.target.disabled = true;
		}

	}


}
</script>



<style>

.custom-select-sm {
	font-size: 0.76563rem;
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}

input[type=date]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}

</style>
